<template>
    <div id="drug-order-items-relocation-container">
        <b-row>
            <b-col sm="12">
                <MdTitle v-bind:Text="$t('DrugOrderItemsRemoval.Title')" />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <!--<MdEdit 
                    v-bind:Label="$t('DrugOrderItemsRemoval.DateReceivedFrom')"
                    v-bind:Name="'dateReceivedFrom'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-model="parameters.dateReceivedFrom"
                />-->                
                <MdDateTime 
                    :Label="$t('DrugOrderItemsRemoval.DateReceivedFrom')" 
                    :Model="parameters.dateReceivedFrom"                           
                    @input="parameters.dateReceivedFrom = $event"                            
                    :Id="'DateReceivedFrom'"
                    :Type="'date'"
                    :OnPressEnter="SearchItems"
                    :isRequired="false"                           
                    :isConfirm="false"
                    :ReadOnly="false">
                </MdDateTime>
            </b-col>  
            <b-col lg="3" md="3" sm="12">
                <!--<MdEdit 
                    v-bind:Label="$t('DrugOrderItemsRemoval.DateReceivedTo')"
                    v-bind:Name="'dateReceivedTo'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-model="parameters.dateReceivedTo"
                /> -->        
                <MdDateTime 
                    :Label="$t('DrugOrderItemsRemoval.DateReceivedTo')" 
                    :Model="parameters.dateReceivedTo"                           
                    @input="parameters.dateReceivedTo = $event"                            
                    :Id="'DateReceivedTo'"
                    :Type="'date'"
                    :OnPressEnter="SearchItems"
                    :isRequired="false"                           
                    :isConfirm="false"
                    :ReadOnly="false">
                </MdDateTime>
            </b-col>  
            <b-col lg="3" md="3" sm="12">
                <!--<MdEdit 
                    v-bind:Label="$t('DrugOrderItemsRemoval.ExpirationDateFrom')"
                    v-bind:Name="'expirationDateFrom'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-model="parameters.expirationDateFrom"
                /> -->              
                <MdDateTime 
                    :Label="$t('DrugOrderItemsRemoval.ExpirationDateFrom')" 
                    :Model="parameters.expirationDateFrom"                           
                    @input="parameters.expirationDateFrom = $event"                            
                    :Id="'ItemRemovalExpirationDateFrom'"
                    :Type="'date'"
                    :OnPressEnter="SearchItems"
                    :isRequired="false"                           
                    :isConfirm="false"
                    :ReadOnly="false">
                </MdDateTime>
            </b-col>  
            <b-col lg="3" md="3" sm="12">
                <!--<MdEdit 
                    v-bind:Label="$t('DrugOrderItemsRemoval.ExpirationDateTo')"
                    v-bind:Name="'expirationDateTo'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-model="parameters.expirationDateTo"
                /> -->
                <MdDateTime 
                    :Label="$t('DrugOrderItemsRemoval.ExpirationDateTo')" 
                    :Model="parameters.expirationDateTo"                           
                    @input="parameters.expirationDateTo = $event"                            
                    :Id="'ItemRemovalExpirationDateTo'"
                    :Type="'date'"
                    :OnPressEnter="SearchItems"
                    :isRequired="false"                           
                    :isConfirm="false"
                    :ReadOnly="false">
                </MdDateTime>
            </b-col>  
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdLookup
                    v-bind:ModelCode="parameters.drugCode"
                    v-bind:ModelDescription="DrugName"
                    v-bind:Label="$t('Medication.Drugs')"                             
                    v-bind:RefCode="'Drugs'"  
                    v-bind:Api="'Drugs'"                                                                
                    v-bind:FieldCode="'drugCode'"  
                    v-bind:FieldDescription="'drugname'"                                         
                    :SearchTitle="$t('Medication.Drugs')"
                    :GetValues="onCodeConditionOk"                     
                    :SearchFieldCode="'Code'"      
                    v-bind:Fields="BaseFields"             
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugOrderItemsRemoval.LotNo')"
                    v-bind:Name="'Lot-number'"
                    v-bind:TypeProp="'text'" 
                    v-bind:OnPressEnter="SearchItems"      
                    v-model="parameters.lotNo"
                    v-bind:Id="'lot-number'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('DrugOrderItemsRemoval.Location')"
                    v-bind:Options="pharmacyLocations"
                    v-bind:ModelArray="pharmacyVModel"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    :Input="changeDropDownPharmacy"/>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('DrugOrderItemsRemoval.ShowLots')"
                    v-bind:Options="ShowLotsOptions"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Tag="'DrugOrderItemsShowLots'"
                    v-bind:RequireEvent="true"
                    v-bind:AllowEmpty="false"
                    v-bind:Multiple="false"
                    v-bind:Model="showAllLotModel"
                    :Input="ChangeShowAllModel"/>
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="12" md="12" sm="12">
                <div class="mt-3 text-right">
                    <button 
                        v-on:click="SearchItems"
                        type="button"
                        class="btn btn-primary btn-login mx-2"
                        id="btnsearchinput">
                        {{ $t('Shared.Search') }}
                    </button>
                </div>
            </b-col>
        </b-row>

        <MdTitle v-bind:Text="viewText" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
        <b-row>
            <b-col lg="12" md="12" sm="12">
                <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                    v-bind:currentPage="parameters.PageNumber"
                    v-bind:perPage="parameters.PageSize"
                    v-bind:pageOptions="pageOptions"
                    v-bind:IsItemRemoval="true"
                    :editIconEvent="editHandler"
                    v-bind:VisibleEditIcon="true"
                    v-bind:VisibleDeleteIcon="false"
                    :onRowSelected="onRowSelected"
                    :onFiltered="onFiltered"
                    :pageChanged="pageChanged"
                    :perPageFunction="perPageFunction"   
                >                
                </MdTable>                
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Report')"
                v-bind:Name="'btnReport'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="ShowReport()"
            />
        </div>

        <DrugOrderItemsRemovalEditDlg
            v-bind:visible="visibleEditDialog"
            v-model="editableItem"
            @close="closeHandler"
            @ok="okHandler"
            :reasonList="this.reasonList"
        >
        </DrugOrderItemsRemovalEditDlg>

         <ItemsRelocationRep 
            :visible="isItemReloReportVisible"
            :closeWindow="closeItemReloReportWindow"
            @close="closeItemReloReportWindow"
            :winTitle="$t('DrugOrderItemsRemoval.Title')"
            :ReportName="'ItemRemoval'"
            :isRelocation=false
        />
    </div>
</template>

<script>
import ePharmacyItemsLocationService from '@/services/epharmacylocation.service'
import ePharmacyItemsReceivedService from '@/services/epharmacyitemsreceived.service'
import EnumService from "@/services/enum.service"
import DBFunctions from '@/common/DBFunctions.js'
import ShowMessage from '@/components/messages/ShowMessage.js';
import Utils from "@/common/utils";
import ReasonService from '@/services/reason.service'
import DrugOrderItemsRemovalEditDlg from './DrugOrderItemsRemovalEditDlg'

export default {
    name: 'DrugOrderItemsRemoval',
    mixins: [DBFunctions, ShowMessage],
    components: {
        DrugOrderItemsRemovalEditDlg
    },

    data() {
        return {
            OptionsRightMenu:{
                visible:false,
                btnvisible:false,
                ItemsList:[],
                favButtonAtion: false
            },
            DrugName:"",
            parameters: {
                dateReceivedFrom: null,
                dateReceivedTo: null,
                expirationDateFrom: null,
                expirationDateTo: null,
                lotNo: null,
                drugCode: null,              
                pharmacyLocation: '',
                showAllLot: 0,
                PageSize: 10,
                PageNumber: 1,
                BuildingRestriction: this.$store.state.restrictions.buildingLocation,
                PharmacyRestriction: this.$store.state.restrictions.pharmacy
            },  
            reasonList: [],
            pharmacyLocations: [],
            pharmacyVModel: null,
            pharmacyToVModel: null,
            pharmacyLocationTo: null,
            ShowLotsOptions: EnumService.DrugOrderItemsShowLots,
            showAllLotModel: {value:0,name: this.$t('Shared.All')},

            items: [],
            showMessageIsEmpty: false,
            totalRows: 0,
            isReadOnly: false,
            pageOptions: [5, 10, 15 ],
            visibleEditDialog: false,
            editableItem: {
                drugName: '',
                activeIngred: '',
                expirationDate:'',
                lotNo:'',
                location: '',
                qtyFilled:'',
                qtyReceived:'',
                qtyAvailable:'',
                qtyToMove: null,
                notes:null,
                reasonCode:null
            },
            editableIndex: -1,
            viewText: `${this.$t('Shared.SearchResult')} - ` +
                `${this.$t('DrugOrderItemsRemoval.Filled')}: 0 - ` +
                `${this.$t('DrugOrderItemsRemoval.Received')}: 0 - ` +
                `${this.$t('DrugOrderItemsRemoval.Available')}: 0`,

            isItemReloReportVisible: false,
            BaseFields:[{ key: 'drugname', sortable: true, label: this.$t('Shared.Description') },{ key: 'drugCode', sortable: true, label: this.$t('Shared.Code')}],
        }
    },

    computed: {
        fields() {
            return [
                { 
                    key: 'dateReceived', 
                    label: this.$t('DrugOrderItemsRemoval.DateReceived'), 
                    formatter: (value) => {
                        return Utils.formatterDateToString(value);
                    }
                },
                {
                    key: 'drugName', 
                    label: this.$tc('DrugOrderItemsRemoval.DrugName',1), 
                },
                { 
                    key: 'activeIngred', 
                    label: this.$t('Shared.activeIngredients'), 
                },              
                { 
                    key: 'expirationDateItemRemoval', 
                    label: this.$t('DrugOrderItemsRemoval.ExpirationDate'), 
                    formatter: (value) => {
                        return Utils.formatterDateToString(value);
                    }
                },
                { 
                    key: 'lotNo', 
                    label: this.$t('DrugOrderItemsRemoval.LotNo'), 
                },
                { 
                    key: 'locationDescription', 
                    label: this.$t('DrugOrderItemsRemoval.Location'), 
                },
                { 
                    key: 'qtyFilled', 
                    label: this.$t('DrugOrderItemsRemoval.Filled'), 
                },
                { 
                    key: 'qtyReceived', 
                    label: this.$t('DrugOrderItemsRemoval.Received'), 
                },
                { 
                    key: 'qtyAvailable', 
                    label: this.$t('DrugOrderItemsRemoval.Available'), 
                },
            ]
        },
    },

    methods: {
        goProcess() {
            let data = {
                itemNo: this.editableItem.itemNo,
                qTYToMove:this.editableItem.qtyToMove,
                reasonCode: this.editableItem.reasonCode,
                notes: this.editableItem.notes,
                drugCode: this.editableItem.drugCode,
                location: this.editableItem.location
            }

            ePharmacyItemsReceivedService
                .processRemoval(data)
                .then((response) => {
                    if(response.status == '200'){
                        this.pendingChanges = false;
                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            })
                            , 50
                        ); 

                        this.SearchItems();
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        onCodeConditionOk(result) {
            var type = result.FieldName;
            if(type.indexOf('Drugs') >= 0) {
                this.parameters.drugCode = Utils.isNullOrEmptyString(result.code) 
                        ? null : result.code.trim();
                this.DrugName = Utils.isNullOrEmptyString(result.description) 
                        ? null : result.description.trim();

                this.currentPage = 1;
                this.SearchItems();
            }
        },

        changeDropDownPharmacy(status) {
            this.parameters.pharmacyLocation = status ? status.code : '';
            this.SearchItems();
        },

        changeDropDownPharmacyTo(status) {
            this.pharmacyLocationTo = status ? status.code : '';
            this.SearchItems();
        },

        ChangeFilter(m){      
            this.modelFilter = m;
        },

        ChangeShowAllModel(item) {
            if (item != null)  {
                this.showAllLotModel = item;
                this.parameters.showAllLot = item ? item.value : 0;
            } else {
                this.showAllLotModel = null;
            }  

            this.SearchItems();
        },

        SearchItems() {
            ePharmacyItemsReceivedService
                .getAvailableForRemoval(this.parameters)
                .then((response) => {
                    if(response.status == '200' && response.data){

                        let data = response.data;

                        data.forEach(element => {
                           element.expirationDateItemRemoval = element.expirationDate; 
                        });
                        this.items = data;

                        let header = JSON.parse(response.headers["x-pagination"]);
                        this.totalRows = header.TotalCount;
                        this.showMessageIsEmpty = this.items.length === 0;
                    }

                    this.SearchItemsTotals()
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        SearchItemsTotals() {
            ePharmacyItemsReceivedService
                .getTotalsAvailableForRemoval(this.parameters)
                .then((response) => {
                    if(response.status == '200'){
                        const totals = response.data || {filled: 0, received: 0, available: 0};

                        this.viewText = `${this.$t('Shared.SearchResult')} - ` +
                            `${this.$t('DrugOrderItemsRemoval.Filled')}: ${totals.filled} - ` +
                            `${this.$t('DrugOrderItemsRemoval.Received')}: ${totals.received} - ` +
                            `${this.$t('DrugOrderItemsRemoval.Available')}: ${totals.available}`
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
            
        },

        getPharmacyLocations() {
            this.pharmacyLocations = [];
            ePharmacyItemsLocationService
                .getAllForRemoval()
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.pharmacyLocations = response.data;
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        getReason() { 
            ReasonService.getReasonInventory()
            .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0){
                    this.reasonList = [                      
                        ...response.data
                            .filter(item => item.active)
                            .map(item => { return {key: item.code, value: item.name}}),
                    ];
                }
            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
        },

        initialize() {
            Promise.all([this.getPharmacyLocations(), this.getReason()]);
        },

        pageChanged(page) {
            this.parameters.PageNumber = page;
            this.SearchItems()
        },
        
        perPageFunction(perPage) {
            this.parameters.PageNumber = 1;
            this.parameters.PageSize = perPage;
            this.SearchItems()
        },

        onRowSelected() {

        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.parameters.PageNumber = 1
        },

        editHandler(value) {
            this.editableIndex = this.items.findIndex(item => item === value);
            this.editableItem = value;
            this.editableItem.expirationDate = Utils.formatterDateToString(this.editableItem.expirationDate);  
            this.editableItem['qtyToMove'] = value.qtyToMove ? value.qtyToMove : null;
            this.visibleEditDialog = true;
        },

        okHandler() {
            this.visibleEditDialog = false;
            this.goProcess();
        },

        closeHandler() {
            this.visibleEditDialog = false;
        },

        ShowReport() {
            this.isItemReloReportVisible = true
        },

        closeItemReloReportWindow() {
            this.isItemReloReportVisible = false
        },
    },

    mounted() {
        this.initialize();
        this.SearchItems();
        this.OptionsRightMenu.visible = false;
        this.OptionsRightMenu.btnDrugOrdersInboxvisible = false;    
        this.OptionsRightMenu.ItemsList = [];
        this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
        case 'L0R1':
            this.OptionsRightMenu.favButtonAtion = true;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = true;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }   
    },
}
</script>